import MODULE_ID from './moduleId';
import routeHandler from './routes';

export default {
  moduleType: 'Fahrdienst452',
  moduleId: MODULE_ID,
  api: 'fahrdienst452',

  routeHandler,
};
